import * as React from 'react';

import {PhDrugRelatedProblemDto} from './PhRecommendationDrpBaseFormatter';
import {PhRecommendationDrpTextFormatter} from './PhRecommendationDrpFormatters';
import {useFormatters} from '../light';

type Props = {
  problems: PhDrugRelatedProblemDto[];
  dividerWidthOffset: number;
};
export const PhRecommendationDrpTypesFormatter: React.FC<Props> = ({problems, dividerWidthOffset}) => {
  const {tEnum} = useFormatters();

  return (
    <PhRecommendationDrpTextFormatter
      dividerWidthOffset={dividerWidthOffset}
      problems={problems}
      getText={(drp) => tEnum('DrpType', drp.type)}
    />
  );
};
PhRecommendationDrpTypesFormatter.displayName = 'PharmaRecommendationDrpTypesFormatter';
